import { Link } from 'react-router-dom';
import { ArrowUp } from 'lucide-react';
import logo from '@/assets/filefinity-logo.png';
import { Button } from './ui/button';

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="fixed bottom-0 w-full border-t border-gray-200 z-10">
      <Button
        onClick={scrollToTop}
        className="fixed bottom-20 right-8 rounded-lg p-2"
        size="icon"
        aria-label="Scroll t  o top"
      >
        <ArrowUp className="h-6 w-6 text-white" />
      </Button>

      <div className="bg-white text-gray-600 px-6 py-2">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-row justify-between items-center h-10 flex-wrap">
            <Link
              to="/"
              className="flex items-center space-x-2 hover:text-gray-900"
            >
              <img src={logo} alt="logo" className="w-auto h-7 rounded-lg " />
              <span className="text-sm max-sm:hidden">Filefinity</span>
            </Link>
            <div className="flex items-center space-x-2 text-sm">
              <Button
                variant="link"
                onClick={() => {
                  window.open('mailto:support@filefinity.com');
                }}
                className="text-gray-600 font-normal border-0 p-0 text-sm"
              >
                support@filefinity.com
              </Button>
              <span className="text-gray-300">|</span>
              <Link to="/privacyPolicy" className="hover:text-gray-900">
                Privacy
              </Link>
            </div>
            <p className="text-xs text-gray-500 max-sm:hidden">
              © {new Date().getFullYear()} - Copyright Filefinity
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
